import React from "react";

import { AppBar, IconButton, Toolbar } from "@mui/material";
import { Menu } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { ReactComponent as UserAvatar } from "libAssets/user-avatar-default.svg";
import WhitelabelLogo from "components/admin/WhitelabelLogo";

interface HeaderProps {
  onDrawerToggle: () => void;
}

export function Header({ onDrawerToggle }: HeaderProps) {
  return (
    <AppBar position="fixed" color="transparent">
      <Toolbar style={{ justifyContent: "space-between" }}>
        <IconButton
          color="primary"
          aria-label="open drawer"
          onClick={onDrawerToggle}
        >
          <Menu />
        </IconButton>
        <WhitelabelLogo isHorizontal />
        <IconButton
          component={Link}
          to="/admin/my-account"
          aria-label="navigate to profile"
        >
          <UserAvatar />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
